var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-avatar",staticStyle:{"margin-right":"8px"}},[(!_vm.isBlank)?_c('img',{attrs:{"src":_vm.value.length && _vm.value[0].publicUrl}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }